import { schemeTypeMap } from '../../../utils/sms/constantsAndUtils';

export const validateProductFetch = (formInput, setFormErrors) => {
  let valid = true;
  const errors = {
    company: '',
    category: '',
  };
  if (formInput.company.length === 0) {
    errors['company'] = 'Cannot be Empty';
    valid = false;
  }
  if (formInput.category.length === 0) {
    errors['category'] = 'Cannot be Empty';
    valid = false;
  }
  setFormErrors((prev) => ({
    ...prev,
    company: errors.company,
    category: errors.category,
  }));
  return valid;
};
export const schemeSubTypeRequired = [
  'Sell-in',
  'Upgrade-offer',
  schemeTypeMap.foc,
];
export const addSchemeValidate = (formInput, setFormErrors) => {
  const errors = { products: [] };
  let valid = true;

  const requiredFields = [
    { field: 'company', message: 'Cannot be Empty' },
    { field: 'category', message: 'Cannot be Empty' },
    { field: 'regions', message: 'Cannot be Empty' },
    { field: 'schemeCircularNo', message: 'Cannot be Empty' },
    { field: 'schemeCircularFile', message: 'Please upload the file' },
    { field: 'type', message: 'Cannot be Empty' },
    { field: 'schemeCircularDate', message: 'Cannot be Empty', isDate: true },
    { field: 'validFrom', message: 'Cannot be Empty', isDate: true },
  ];
  if (![schemeTypeMap.priceDrop].includes(formInput.type?.[0])) {
    requiredFields.push({
      field: 'validTill',
      message: 'Cannot be Empty',
      isDate: true,
    });
  }

  if (
    schemeSubTypeRequired.includes(formInput.type?.[0]) &&
    (!formInput.sellIntype || formInput.sellIntype.length === 0)
  ) {
    errors.sellIntype = 'Cannot be Empty';
    valid = false;
  }

  if (formInput.type?.[0] === schemeTypeMap.foc && !formInput.focType) {
    errors.focType = 'Cannot be Empty';
  }

  if (
    formInput.validFrom &&
    formInput.validTill &&
    formInput.validFrom > formInput.validTill
  ) {
    errors.validFrom = 'Cannot be greater than Valid Till';
    valid = false;
  }

  requiredFields.forEach(({ field, message }) => {
    if (!formInput[field] || formInput[field].length === 0) {
      errors[field] = message;
      valid = false;
    }
  });
  if (formInput.type?.[0] !== schemeTypeMap.reimbursement) {
    formInput.products.forEach((item, index) => {
      const productErrors = {};
      const productFields = [];
      if (
        ![schemeTypeMap.marketing, schemeTypeMap.foc].includes(
          formInput?.type?.[0]
        )
      ) {
        productFields.push({
          field: 'productName',
          message: 'Cannot be Empty',
        });
        productFields.push({ field: 'payout', message: 'Cannot be Empty' });
      }
      if (['Upgrade-offer', 'Liquidation'].includes(formInput?.type?.[0])) {
        productFields.push({
          field: 'brandAmount',
          message: 'Cannot be Empty',
        });
      }
      if (
        formInput?.products?.some(
          (item) => item?.valuationType?.[0]?.toLowerCase() === 'percentage'
        )
      ) {
        productFields.push({
          field: 'payoutBasis',
          message: 'Cannot be Empty',
        });
      }
      productFields.forEach(({ field, message }) => {
        if (!item[field] || item[field].length === 0) {
          productErrors[field] = message;
          valid = false;
        }
      });

      if (['Upgrade-offer', 'Liquidation'].includes(formInput?.type?.[0])) {
        const vsAmount = Number(item?.vsAmount) || 0;
        const brandAmount = Number(item?.brandAmount) || 0;
        const payout = Number(item?.payout) || 0;

        if (vsAmount + brandAmount !== payout) {
          productErrors.payout =
            'vsAmount + brandAmount must be equal to payout';
          valid = false;
        }
      }
      if (
        ![schemeTypeMap.marketing, schemeTypeMap.foc].includes(
          formInput?.type?.[0]
        ) &&
        (!item?.valuationType.length ||
          !['value', 'percentage'].includes(
            item?.valuationType?.[0]?.toLowerCase()
          ))
      ) {
        productErrors.valuationType = 'valuationType must be valid';
        valid = false;
      }
      if (
        item?.valuationType?.[0]?.toLowerCase() === 'percentage' &&
        item.payout > 100
      ) {
        productErrors.payout = 'Cannot be more than 100';
        valid = false;
      }
      if (Object.keys(productErrors).length > 0) {
        errors.products[index] = productErrors;
      }
    });
  }
  console.log(errors);
  setFormErrors(errors);
  return valid;
};

export const addProductValidate = (formInput, setFormErrors, type) => {
  const errors = {};
  let valid = true;

  if (type === 'addProduct') {
    if (!formInput.productName) {
      errors.productName = 'Cannot be empty';
      valid = false;
    }
    if (!formInput.vanNo) {
      errors.vanNo = 'Cannot be empty';
      valid = false;
    }
    if (!formInput.company) {
      errors.company = 'Cannot be empty';
      valid = false;
    }
    if (!formInput.category) {
      errors.category = 'Cannot be empty';
      valid = false;
    }
  }

  if (type === 'addCompany') {
    if (!formInput.newCompanyName) {
      errors.newCompanyName = 'Cannot be empty';
      valid = false;
    }
  }

  if (type === 'addCategory') {
    if (!formInput.companyName) {
      errors.companyName = 'Cannot be empty';
      valid = false;
    }
    if (!formInput.newCategoryName) {
      errors.newCategoryName = 'Cannot be empty';
      valid = false;
    }
  }

  setFormErrors(errors);
  return valid;
};
